import styled from 'styled-components';
import { theme } from 'styled';
import { getTheme, parseProp, parseTheme } from 'mol-ui';

const _getStatusColor = status => {
    const {
        secondaryColor,
        statusAvailable,
        statusBussy,
        statusUnavailable
    } = theme;
    switch (status) {
    case 'Disponible':
        return statusAvailable;
    case 'En Sesión':
        return statusBussy;
    case 'No Disponible':
        return statusUnavailable;
    default:
        return secondaryColor;
    }
};

export const Avatar = styled.img`
    border-radius: 100%;
    height: 65px;
    object-fit: cover;
    width: 65px;
`;

export const Actions = styled.div`
    display: flex;
`;

export const ActiveContainer = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-right: 30px;
    min-width: 100px;
`;

export const ComponentContainer = styled.div`
    font-size: 12px;
    height: 50%;
    position: relative;
    ${ ({ right }) => right ? `right: ${ right };` : '' }
    text-align: ${ ({ textAlign }) => textAlign ? textAlign : 'left' };
    ${ ({ top }) => top ? `top: ${ top };` : '' }
`;

export const Container = styled.div`
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    display: flex;
    justify-content: space-between;
    min-width: 600px;
    padding: 10px 20px;
    width: 100%;
    :last-child {
        border-bottom: none;
    }
`;

export const Icon = styled.div`
    ${ parseProp('color', 'background') }
    border-radius: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    margin-right: 25px;
    min-height: 65px;
    min-width: 65px;
`;

export const IconContainer = styled.div`
    cursor: pointer;
    margin-left: 5px;
`;

export const Info = styled.div`
    align-items: center;
    display: flex;
`;

export const Status = styled.p`
    color: ${ ({ status }) => _getStatusColor(status) };
    font-size: .8rem;
    margin: 0;
`;

export const Text = styled.p`
    ${ parseTheme('color', 'textColor') }
    font-size: 11px;
    margin: 0;
`;

export const Title = styled.p`
    color: ${ ({ color, theme: { textColor } }) => color ? color : textColor };
    font-weight: 500;
    font-size: .9rem;
    margin: 0;
`;
